// extracted by mini-css-extract-plugin
export default {"page_heading":"banner_page_heading__+wcCw"};